"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.MainNavLink = exports.NavItemContainer = exports.ExpandedLinksWrapper = exports.SubNavItemTextHome = exports.SubNavItemContainerHome = exports.SubNavItemContainer = exports.SubNavItemSolo = exports.SubNavItemText = exports.SubNavLink = exports.NavItemSoloDescription = exports.NavItemDescription = exports.NavItemText = exports.NavItemIcon = exports.NavItem = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _styledSystem = require("styled-system");

var _Layout = require("../../../Layout");

var _Typography = require("../../../Typography");

var _Link = _interopRequireDefault(require("../../../Link"));

var _sharedStyle = require("../../../../styles/sharedStyle");

var _mediaQueries = _interopRequireDefault(require("../../../../styles/mediaQueries"));

var _Icon = _interopRequireDefault(require("../../../Icon"));

var NavItem = (0, _styled.default)('div')(function (_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      globalNav = _ref$theme.globalNav,
      isExpanded = _ref.isExpanded;
  return _defineProperty({
    backgroundColor: isExpanded ? colors[globalNav.navItemExpandedBgHeader] : colors.none,
    transition: isExpanded ? 'all 0.2s ease-in-out' : 'all 0.5s ease-out'
  }, _mediaQueries.default.medium, {
    background: 'transparent',
    border: 'none'
  });
}, function (_ref3) {
  var colors = _ref3.theme.colors,
      isExpanded = _ref3.isExpanded;
  return (0, _styledSystem.variant)({
    prop: 'variation',
    variants: {
      primary: {
        backgroundColor: isExpanded ? colors.secondary : colors.none
      }
    }
  });
});
exports.NavItem = NavItem;
var NavItemIcon = (0, _styled.default)(_Icon.default)(function (_ref4) {
  var _ref4$theme = _ref4.theme,
      colors = _ref4$theme.colors,
      globalNav = _ref4$theme.globalNav;
  return {
    svg: {
      stroke: colors[globalNav.navItemIconColorHeader]
    }
  };
}, function (_ref5) {
  var colors = _ref5.theme.colors;
  return (0, _styledSystem.variant)({
    prop: 'variation',
    variants: {
      primary: {
        svg: {
          stroke: colors.primary
        }
      }
    }
  });
});
exports.NavItemIcon = NavItemIcon;
var NavItemText = (0, _styled.default)(_Typography.Body)(function (_ref6) {
  var _ref6$theme = _ref6.theme,
      colors = _ref6$theme.colors,
      globalNav = _ref6$theme.globalNav,
      isExpanded = _ref6.isExpanded;
  return _objectSpread(_objectSpread({}, (0, _sharedStyle.textHover)({
    color: isExpanded ? colors[globalNav.navItemTextColorHeaderExpandedMobile] : colors[globalNav.navItemTextColorHeaderMobile],
    weight: 'bold',
    width: '2px'
  })), {}, _defineProperty({
    fontSize: globalNav.navItemHeaderFontSize,
    textTransform: globalNav.navItemTextTransform
  }, _mediaQueries.default.medium, _objectSpread({}, (0, _sharedStyle.removeTextHover)(colors[globalNav.navItemTextColorHeaderDesktop]))));
}, function (_ref7) {
  var _ref7$theme = _ref7.theme,
      colors = _ref7$theme.colors,
      globalNav = _ref7$theme.globalNav,
      isExpanded = _ref7.isExpanded;
  return (0, _styledSystem.variant)({
    prop: 'variation',
    variants: {
      primary: _objectSpread(_objectSpread({}, (0, _sharedStyle.textHover)({
        color: isExpanded ? "".concat(colors[globalNav.primaryNavItemTextColor]) : colors[globalNav.primaryNavItemTextColor],
        weight: 'bold',
        width: '2px'
      })), {}, _defineProperty({
        fontSize: globalNav.navItemHeaderFontSize,
        textTransform: globalNav.navItemTextTransform
      }, _mediaQueries.default.medium, _objectSpread({}, (0, _sharedStyle.removeTextHover)(colors[globalNav.primaryNavItemTextColor]))))
    }
  });
});
exports.NavItemText = NavItemText;
var NavItemDescription = (0, _styled.default)('p')(function (_ref8) {
  var _ref8$theme = _ref8.theme,
      space = _ref8$theme.space,
      globalNav = _ref8$theme.globalNav;
  return {
    opacity: globalNav.navItemDescriptionOpacity,
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    marginBottom: space.small,
    '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
      width: '100%'
    }
  };
});
exports.NavItemDescription = NavItemDescription;
var NavItemSoloDescription = (0, _styled.default)(NavItemDescription)(_defineProperty({}, _mediaQueries.default.untilMedium, {
  display: 'none'
}));
exports.NavItemSoloDescription = NavItemSoloDescription;
var SubNavLink = (0, _styled.default)(_Link.default)(function (_ref10) {
  var space = _ref10.theme.space;
  return _defineProperty({
    display: 'block',
    padding: "".concat(space.medium, " 0 ").concat(space.medium, " ").concat(space.medium),
    width: '100%'
  }, _mediaQueries.default.medium, {
    display: 'inline-block',
    width: 'auto',
    padding: "".concat(space.small, " 0")
  });
});
exports.SubNavLink = SubNavLink;
var SubNavItemText = (0, _styled.default)('div')(function (_ref12) {
  var _ref12$theme = _ref12.theme,
      colors = _ref12$theme.colors,
      globalNav = _ref12$theme.globalNav,
      active = _ref12.active,
      isExpanded = _ref12.isExpanded;
  return _objectSpread({}, (0, _sharedStyle.textHover)({
    color: isExpanded ? colors[globalNav.subNavItemColorHeaderExpanded] : colors[globalNav.subNavItemColorHeader],
    hover: colors[globalNav.subNavItemColorHoverHeader],
    weight: 'bold',
    width: '2px',
    active: active
  }));
}, function (_ref13) {
  var colors = _ref13.theme.colors,
      active = _ref13.active;
  return (0, _styledSystem.variant)({
    prop: 'variation',
    variants: {
      primary: _objectSpread({}, (0, _sharedStyle.textHover)({
        color: colors.primary,
        weight: 'normal',
        width: '2px',
        active: active
      }))
    }
  });
});
exports.SubNavItemText = SubNavItemText;
var SubNavItemSolo = (0, _styled.default)(NavItemText)(function (_ref14) {
  var _ref14$theme = _ref14.theme,
      space = _ref14$theme.space,
      colors = _ref14$theme.colors,
      globalNav = _ref14$theme.globalNav;
  return _objectSpread(_objectSpread({}, (0, _sharedStyle.textHover)({
    color: "".concat(colors[globalNav.subNavItemSoloColor]),
    hover: "".concat(colors[globalNav.subNavItemSoloColorHover]),
    weight: 'bold',
    width: '2px'
  })), {}, _defineProperty({
    display: 'inline-block',
    fontSize: globalNav.navItemHeaderFontSize,
    textTransform: globalNav.navItemTextTransform,
    marginTop: '0',
    marginBottom: space.small,
    paddingBottom: '0'
  }, _mediaQueries.default.medium, _objectSpread(_objectSpread({}, (0, _sharedStyle.textHover)({
    color: "".concat(colors[globalNav.subNavItemSoloColor]),
    hover: "".concat(colors[globalNav.subNavItemSoloColorHover]),
    weight: 'bold',
    width: '2px'
  })), {}, {
    display: 'inline-block'
  })));
}, function (_ref15) {
  var _ref15$theme = _ref15.theme,
      colors = _ref15$theme.colors,
      globalNav = _ref15$theme.globalNav;
  return (0, _styledSystem.variant)({
    prop: 'variation',
    variants: {
      mega: _objectSpread({}, (0, _sharedStyle.textHover)({
        color: "".concat(colors[globalNav.subNavItemSoloColorMega], " !important"),
        hover: "".concat(colors[globalNav.subNavItemSoloColorMegaHover], " !important"),
        weight: 'bold',
        width: '2px'
      }))
    }
  });
});
exports.SubNavItemSolo = SubNavItemSolo;
var SubNavItemContainer = (0, _styled.default)(_Layout.Container)(_defineProperty({
  width: '100%',
  '&:first-of-type > a': {
    borderTop: 'none'
  }
}, _mediaQueries.default.medium, {
  padding: '0'
}));
exports.SubNavItemContainer = SubNavItemContainer;
var SubNavItemContainerHome = (0, _styled.default)(SubNavItemContainer)(function (_ref17) {
  var _ref18;

  var _ref17$theme = _ref17.theme,
      globalNav = _ref17$theme.globalNav,
      space = _ref17$theme.space,
      link = _ref17.link;
  return _ref18 = {
    borderBottom: '0',
    marginBottom: '2rem',
    position: 'relative'
  }, _defineProperty(_ref18, _mediaQueries.default.medium, {
    minHeight: link.url ? '12rem' : 'auto',
    borderBottom: link.url ? globalNav.subNavItemContainerHomeBorder : '0',
    paddingLeft: '0',
    paddingRight: '0'
  }), _defineProperty(_ref18, _mediaQueries.default.xlarge, {
    minHeight: link.url ? '13rem' : 'auto'
  }), _defineProperty(_ref18, '&:first-of-type > a', _defineProperty({
    borderBottom: link.url ? globalNav.subNavItemContainerHomeBorder : '0',
    paddingLeft: '0'
  }, _mediaQueries.default.medium, {
    borderBottom: '0',
    position: 'absolute',
    bottom: space.base
  })), _ref18;
}, function (_ref19) {
  var _primary;

  var _ref19$theme = _ref19.theme,
      space = _ref19$theme.space,
      globalNav = _ref19$theme.globalNav,
      link = _ref19.link;
  return (0, _styledSystem.variant)({
    prop: 'variation',
    variants: {
      primary: (_primary = {}, _defineProperty(_primary, _mediaQueries.default.medium, {
        borderBottom: link.url ? globalNav.primarySubNavItemContainerHomeBorder : '0'
      }), _defineProperty(_primary, '&:first-of-type > a', _defineProperty({
        borderBottom: link.url ? globalNav.primarySubNavItemContainerHomeBorder : '0'
      }, _mediaQueries.default.medium, {
        borderBottom: '0',
        position: 'absolute',
        bottom: space.base
      })), _primary)
    }
  });
});
exports.SubNavItemContainerHome = SubNavItemContainerHome;
var SubNavItemTextHome = (0, _styled.default)(SubNavItemText)(function (_ref20) {
  var _ref20$theme = _ref20.theme,
      globalNav = _ref20$theme.globalNav,
      colors = _ref20$theme.colors,
      isExpanded = _ref20.isExpanded;
  return {
    borderBottom: globalNav.subNavItemTextHomeBorder,
    borderColor: isExpanded ? colors[globalNav.subNavItemTextHomeExpandedBorderColor] : colors[globalNav.subNavItemTextHomeBorderColor]
  };
}, function (_ref21) {
  var globalNav = _ref21.theme.globalNav;
  return (0, _styledSystem.variant)({
    prop: 'variation',
    variants: {
      primary: {
        borderBottom: globalNav.primarySubNavItemTextHomeBorderColor,
        marginLeft: '0'
      }
    }
  });
});
exports.SubNavItemTextHome = SubNavItemTextHome;
var ExpandedLinksWrapper = (0, _styled.default)('div')(function (_ref22) {
  var _ref22$theme = _ref22.theme,
      colors = _ref22$theme.colors,
      space = _ref22$theme.space,
      isExpanded = _ref22.isExpanded;
  return _defineProperty({
    overflow: 'hidden',
    height: 'auto',
    transition: isExpanded ? 'max-height 0.4s ease-in-out, opacity 0.4s ease-in-out' : 'max-height 0.4s ease-in-out, opacity 0.1s 0.39s ease-in-out',
    maxHeight: isExpanded ? '800px' : '0',
    opacity: isExpanded ? '1' : '0',
    background: colors.none,
    paddingTop: '0 !important'
  }, _mediaQueries.default.medium, {
    padding: "".concat(space.small, " 0"),
    background: 'transparent'
  });
});
exports.ExpandedLinksWrapper = ExpandedLinksWrapper;
var NavItemContainer = (0, _styled.default)(_Layout.Container)(function (props) {
  return _defineProperty({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '12px',
    paddingBottom: '12px',
    cursor: props.regularLink ? 'auto' : 'pointer'
  }, _mediaQueries.default.medium, {
    cursor: 'initial',
    paddingLeft: '0',
    paddingRight: '0',
    flexDirection: 'column',
    alignItems: 'flex-start'
  });
});
exports.NavItemContainer = NavItemContainer;
var MainNavLink = (0, _styled.default)(_Link.default)(function (_ref25) {
  var _ref26;

  var _ref25$theme = _ref25.theme,
      colors = _ref25$theme.colors,
      globalNav = _ref25$theme.globalNav;
  return _ref26 = {
    display: 'block',
    width: '100%',
    fontWeight: 'bold'
  }, _defineProperty(_ref26, _mediaQueries.default.medium, {
    border: 'none',
    display: 'inline-block',
    width: 'auto'
  }), _defineProperty(_ref26, '&:hover', {
    span: {
      border: '0 !important',
      color: "".concat(colors.greydark, " !important"),
      borderBottom: "0",
      '>h4': {
        color: colors[globalNav.MainNavLinkH4Color],
        borderColor: colors[globalNav.MainNavLinkH4Color]
      }
    }
  }), _ref26;
});
exports.MainNavLink = MainNavLink;